export const getCommitmentsRecommendationsPostFixedCacheKey = (
  orgId?: string | null,
) =>
  `postUsersMeOrganisationsCurrentSavingsPlansRecommendations-${orgId}-fixed-cache-key`;
